import { createFeatureSelector, createSelector, Selector } from '@ngrx/store';
import { Dictionary } from '@ngrx/entity';

import * as fromState from './restrictions-profile.state';
import * as fromReducer from './restrictions-profile.reducer';

import { AppleRestrictionsProfilePreset } from '@rocksoft/mdm-sdk-v2';

export const selectRestrictionsProfileState: Selector<object, fromState.RestrictionsProfileState> =
  createFeatureSelector<fromState.RestrictionsProfileState>('restrictionProfiles');

export const selectRestrictionsProfileIds: Selector<object, string[] | number[]> = createSelector(
  selectRestrictionsProfileState,
  fromReducer.selectRestrictionsProfileIds
);

export const selectRestrictionsProfileEntities: Selector<
  object,
  Dictionary<AppleRestrictionsProfilePreset>
> = createSelector(selectRestrictionsProfileState, fromReducer.selectRestrictionsProfileEntities);

export const selectAllRestrictionsProfiles: Selector<object, AppleRestrictionsProfilePreset[]> = createSelector(
  selectRestrictionsProfileState,
  fromReducer.selectAllRestrictionsProfiles
);

export const selectAllRestrictionsProfilesLoaded: Selector<object, boolean> = createSelector(
  selectAllRestrictionsProfiles,
  (settings) => settings && settings.length > 0
);
